import styled from 'styled-components'

export const TablesContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 16px 32px;
`

export const Footer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
`
